import { render, staticRenderFns } from "./AnswerTypeCheckbox.vue?vue&type=template&id=591ba06c&scoped=true"
import script from "./AnswerTypeCheckbox.vue?vue&type=script&lang=js"
export * from "./AnswerTypeCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeCheckbox.vue?vue&type=style&index=0&id=591ba06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ba06c",
  null
  
)

export default component.exports